import React from 'react'

function Overlay({ onClose }) {
    // const BMSClicked = () => {
    //     onClose();
    // };
    // function BMSClicked() {
    //     document.querySelector('.overlay').style.display = 'none';
    // }
    function ESSClicked() {
        window.location.href = 'https://ess.aeidth.com/'
    }
    return (
        <div className="overlay">
            <div className="card-container">
                <div className="card card1" onClick={onClose}>
                    <h2>Electric Vehicle Ecosystem</h2>
                    <img src="./BMS.png" alt="BMS" className="card-image" />
                </div>
                <div className="card card2" onClick={ESSClicked}>
                    <h2>Energy Storage System</h2>
                    <img src="./ESS.png" alt="ESS" class="card-image" />
                </div>
            </div>
        </div>
    )
}

export default Overlay